export const PipelineStatus = {
  ACTIVE: 1,
  ARCHIVED: 0
};

export const PipelineStatusOptions = [
  { value: PipelineStatus.ARCHIVED, label: 'Archived', mode: 'disabled' },
  { value: PipelineStatus.ACTIVE, label: 'Active', mode: 'success' }
];
